import { render } from "./BaseChart.vue?vue&type=template&id=4839d9f6&ts=true"
import script from "./BaseChart.vue?vue&type=script&lang=ts"
export * from "./BaseChart.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__